/**
 * South African rand.
 */
export var ZAR = {
  code: 'ZAR',
  base: 10,
  exponent: 2
};